import React from 'react';
import { SvgIcon } from 'material-ui';

const BootscriptIcon = ({ size = 24, style, ...rest }) => {
    return (
        <SvgIcon { ...rest }
            style={{
                height: size,
                width: size,
                ...style,
            }}
        >
            <path transform="translate(.3)" d="M7,3.66666667 L13.6666667,3.66666667 L18.6666667,8.66666667 L18.6666667,18.6666667 C18.6666667,19.5833333 17.9166667,20.3333333 17,20.3333333 L6.99166667,20.3333333 C6.075,20.3333333 5.33333333,19.5833333 5.33333333,18.6666667 L5.34166667,5.33333333 C5.34166667,4.41666667 6.08333333,3.66666667 7,3.66666667 Z M12.7225867,15.4566801 L12.3762844,15.4566801 L12.3762844,15.8029825 L12.3762844,16.5311039 L12.3762844,16.8774063 L12.7225867,16.8774063 L15.7439506,16.8774063 L16.090253,16.8774063 L16.090253,16.5311039 L16.090253,15.8029825 L16.090253,15.4566801 L15.7439506,15.4566801 L12.7225867,15.4566801 Z M8.62855849,15.3392451 L8.91745758,15.1691225 L12.0953335,13.2977823 L12.265914,13.1973334 L12.265914,12.9993746 L12.265914,12.6591309 L12.265914,12.4665384 L12.1023014,12.3649374 L8.92442543,10.3915241 L8.63282776,10.2104463 L8.44917285,10.5004277 L8.06129506,11.1128664 L7.87208709,11.4116158 L8.17472983,11.5945317 L10.1470439,12.7969143 L8.17773894,13.9601027 L7.8701615,14.1417761 L8.06129506,14.443566 L8.44917285,15.0560046 L8.62855849,15.3392451 Z M12.8333333,9.5 L17.4166667,9.5 L12.8333333,4.91666667 L12.8333333,9.5 Z" id="path-1"></path>
        </SvgIcon>
    );
}

export default BootscriptIcon



// WEBPACK FOOTER //
// ./src/cyverse-ui/icons/BootscriptIcon.js